import "./Regulatory.module.css";
import Header from "@/reusable_sections/Header";
import RegulatoryNavigator from "./sections/RegulatoryNavigator";
import ComplianceExperts from "./sections/ComplianceExperts";
import ComplianceInquiry from "./sections/ComplianceInquiry";
import SiteFooter from "@/reusable_sections/Footer";
export default function RegulatoryPage() {
  return <div>
      <Header />
      <RegulatoryNavigator />
      <ComplianceExperts />
      <ComplianceInquiry />
      <SiteFooter />
    </div>;
}